import {FormProvider} from 'react-hook-form'
import PropTypes from 'prop-types'

import Form from './Form'

const FormWrapper = props => (
  <FormProvider {...props.methods}>
    <Form onSubmit={props.handleSubmit}>{props.children}</Form>
  </FormProvider>
)

FormProvider.propTypes = {
  methods: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired
}

export default FormWrapper
